<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 700px">
            <v-card-title primary-title>
              <div>
                <div class="headline ps-2 pa-1">
                  {{ priceRule.pull_down_cluster_title }}
                </div>
              </div>
            </v-card-title>
            <v-flex>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <label style="font-size: large">{{
                  $t("priceRulesPage.minPriceFor", {
                    cluster: priceRule.pull_down_cluster_title,
                  })
                }}</label>
                <v-text-field
                  outline
                  v-model="priceRule.minPrice"
                  :label="$t('priceRulesPage.minPriceValue')"
                  type="text"
                  style="margin-top: 15px"
                ></v-text-field>

                <label style="font-size: large">{{
                  $t("priceRulesPage.maxPriceFor", {
                    cluster: priceRule.pull_down_cluster_title,
                  })
                }}</label>
                <v-text-field
                  outline
                  v-model="priceRule.maxPrice"
                  :label="$t('priceRulesPage.maxPriceValue')"
                  type="text"
                  style="margin-top: 15px"
                ></v-text-field>

                <label style="font-size: large">{{
                  $t("priceRulesPage.minTimeFor", {
                    cluster: priceRule.pull_down_cluster_title,
                  })
                }}</label>
                <v-text-field
                  outline
                  v-model="priceRule.minTime"
                  :label="$t('priceRulesPage.minTimeValue')"
                  type="text"
                  style="margin-top: 15px"
                ></v-text-field>

                <v-btn :loading="loading" block @click="save" color="secondary"
                  >{{ $t("shared.common.save") }}
                </v-btn>
              </v-form>
            </v-flex>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "Edit_Price_Rules",
  title() {
    return this.$t("priceRulesPage.editPageTitle");
  },
  components: {},

  data() {
    return {
      loading: false,
      form: false,
      priceRule: {
        pull_down_cluster_title: "",
        pull_down_location_cluster_id: 0,
        minPrice: 0.0,
        maxPrice: 0.0,
        minTime: 0,
      },
    };
  },
  created() {
    this.axios.get(`priceRule/${this.$route.params.id}`).then(({ data }) => {
      this.priceRule.pull_down_cluster_title =
        data.data.pull_down_location_cluster_title;
      this.priceRule.pull_down_location_cluster_id =
        data.data.pull_down_location_cluster_id;
      this.priceRule.minPrice = data.data.min_price;
      this.priceRule.maxPrice = data.data.max_price;
      this.priceRule.minTime = data.data.min_time;
    });
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) {
        window.getApp.$emit(
          "SHOW_TOAST",
          this.$t("priceRulesPage.enterValidNumber"),
          "red"
        );
        return;
      }
      this.loading = true;

      this.axios
        .put(`priceRule/${this.$route.params.id}`, {
          pull_down_location_cluster_id:
            this.priceRule.pull_down_location_cluster_id,
          min_price: this.priceRule.minPrice,
          max_price: this.priceRule.maxPrice,
          min_time: this.priceRule.minTime,
        })
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("priceRulesPage.toastSaved"));
          this.$router.push(`/priceRules`);
        })
        .catch(({ response }) => {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("priceRulesPage.toastSaveFailed"),
            "red"
          );
          console.log(response);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
